import React from "react";
import ContactInput from "./inputs/contact/ContactInput";
import {
  CONTACT_CONTACT_EMAIL,
  CONTACT_CONTACT_FIRST_NAME,
  CONTACT_CONTACT_LAST_NAME,
  CONTACT_CONTACT_MOBILE_NUMBER,
  CONTACT_CONTACT_PHONE_EXT,
  CONTACT_CONTACT_PHONE_NUMBER,
  CONTACT_CONTACT_TITLE,
} from "src/shared/contacts/forms/inputs/contact/IContactData";

export interface IContactContactFormProps {
  isContactPhoneNoRequired?: boolean;
}

export default ({ isContactPhoneNoRequired }: IContactContactFormProps) => (
  <ContactInput
    contactFirstNameInputID={CONTACT_CONTACT_FIRST_NAME}
    contactLastNameInputID={CONTACT_CONTACT_LAST_NAME}
    contactTitleInputID={CONTACT_CONTACT_TITLE}
    contactEmailInputID={CONTACT_CONTACT_EMAIL}
    contactPhoneNumberInputID={CONTACT_CONTACT_PHONE_NUMBER}
    contactPhoneExtInputID={CONTACT_CONTACT_PHONE_EXT}
    contactMobileNumberInputID={CONTACT_CONTACT_MOBILE_NUMBER}
    isContactPhoneNoRequired={isContactPhoneNoRequired}
  />
);
